import React, { useEffect, useState } from "react";
import { Col, Drawer } from "antd";
import CustomList from "../../../../components/List";
import ListItem from "../../../../components/ListItem";
import CustomPagination from "../../../../components/CustomPagination";
import { useRelocationUtilities } from "../../../../../hooks/useDataHooks";
import useProcuringEntityPackage from "../../../../../hooks/useProcuringEntityPackage";
import { useReportDateRange } from "../../../../../hooks/useReportDateRange";
import ActionBar from "../../../../components/ActionBar";

const sub_project_name = { xxl: 3, xl: 3, lg: 3, md: 3, sm: 12, xs: 12 };
const Description = { xxl: 3, xl: 3, lg: 3, md: 3, sm: 12, xs: 12 };
const chainage_of_occurrence = { xxl: 4, xl: 4, lg: 4, md: 4, sm: 0, xs: 0 };
const Responsible_Parties = { xxl: 4, xl: 4, lg: 4, md: 4, sm: 12, xs: 12 };
const status = { xxl: 4, xl: 4, lg: 4, md: 4, sm: 0, xs: 0 };
const Remarks = { xxl: 4, xl: 4, lg: 4, md: 4, sm: 0, xs: 0 };

const headerLayout = [
  { ...sub_project_name, header: "Sub Project" },
  { ...Description, header: "Description" },
  { ...chainage_of_occurrence, header: "Chainage of Occurrence" },
  { ...Responsible_Parties, header: "Responsible Parties" },
  { ...status, header: "Current Status" },
  { ...Remarks, header: "Remarks" },
];

const StatusRelocation = ({ match }) => {
  const {
    params: { packageId },
  } = match;
  const { startDate, endDate } = useReportDateRange();
  
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const { relocationUtilities = [], pagination, loading } = useRelocationUtilities(
    packageId,
    startDate,
    endDate,
    currentPage,
    pageSize
  );

  const [activeItem, setActiveItem] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { procuringEntityPackage } = useProcuringEntityPackage(packageId);
  const packageName = procuringEntityPackage?.name;

  const handleRowClick = (item) => {
    setActiveItem(item);
    setVisible(true);
  };

  const handleCloseDrawer = () => {
    setVisible(false);
  };

  const handlePageChange = (page, size) => {
    setCurrentPage(page);
    if (size !== pageSize) {
      setPageSize(size);
    }
  };

  return (
    <>
      <div style={{ padding: "16px" }}>
        <ActionBar actionButtonProp={{
          title: `${packageName || "==//=="}: Status of Relocation of Utilities`,
        }} />
        <div className="prst-table">
        <CustomList
          itemName={`Status of Relocation of Utilities`}
          showToolbar={false}
          items={relocationUtilities || []}
          page={currentPage}
          itemCount={pagination?.total || (relocationUtilities?.length ?? 0)}
          loading={loading}
          headerLayout={headerLayout}
          renderListItem={({ item }) => (
            <ListItem
              key={item?.package_number} 
              name={item?.subProjectName || "==//=="}
              item={item}
              isPackage={false}
              onClick={() => handleRowClick(item)}
              style={{
                backgroundColor:
                  activeItem?.package_number === item?.package_number
                    ? "#f0f0f0"
                    : "transparent",
              }}
            >
              <Col 
                {...sub_project_name} 
                className="contentEllipse"
                data-label="Sub Project"
              >
                {item?.subProjectName?.length > 20 ? item?.subProjectName.slice(0, 20) + "..." : item?.subProjectName || "==//=="}
              </Col>

              <Col 
                {...Description} 
                className="contentEllipse"
                data-label="Description"
              >
                {item?.Description?.length > 20 ? item?.Description.slice(0, 20) + "..." : item?.Description || "==//=="}
              </Col>

              <Col
                {...chainage_of_occurrence}
                className="contentEllipse centerAlign"
                data-label="Chainage of Occurrence"
              >
                {item?.chainage_of_occurrence?.length > 20 ? item?.chainage_of_occurrence.slice(0, 20) + "..." : item?.chainage_of_occurrence || "==//=="}
              </Col>

              <Col 
                {...Responsible_Parties} 
                className="contentEllipse"
                data-label="Responsible Parties"
              >
                {item?.Responsible_Parties?.length > 20 ? item?.Responsible_Parties.slice(0, 20) + "..." : item?.Responsible_Parties || "-"}
              </Col>

              <Col 
                {...status} 
                className="contentEllipse centerAlign"
                data-label="Current Status"
              >
                {item?.status?.length > 20 ? item?.status.slice(0, 20) + "..." : item?.status || "==//=="}
              </Col>

              <Col 
                {...Remarks} 
                className="contentEllipse"
                data-label="Remarks"
              >
                {item?.Remarks?.length > 20 ? item?.Remarks.slice(0, 20) + "..." : item?.Remarks || "==//=="}
              </Col>
              
              <button 
                className="view-card-details" 
                onClick={() => handleRowClick(item)}
              >
                View Details
              </button>
            </ListItem>
          )}
        />
        </div>

        {pagination && (
          <CustomPagination
            pagination={pagination}
            onPageChange={handlePageChange}
            loading={loading}
          />
        )}

        {activeItem && (
          <Drawer
            title={`Status of Relocation of Utilities`}
            placement="right"
            closable={true}
            onClose={handleCloseDrawer}
            visible={visible}
            width={720}
          >
            <p>
              <strong>Sub Project Name:</strong>{" "}
              {activeItem?.subProjectName || "==//=="}
            </p>
            <p>
              <strong>Description:</strong> {activeItem?.Description || "==//=="}
            </p>
            <p>
              <strong>Chainage of Occurrence:</strong>{" "}
              {activeItem?.chainage_of_occurrence || "==//=="}
            </p>
            <p>
              <strong>Responsible Parties:</strong>{" "}
              {activeItem?.Responsible_Parties || "==//=="}
            </p>
            <p>
              <strong>Current Status:</strong> {activeItem?.status || "==//=="}
            </p>
            <p>
              <strong>Remarks:</strong> {activeItem?.Remarks || "==//=="}
            </p>
          </Drawer>
        )}
      </div>
    </>
  );
};

export default StatusRelocation;
